import React from 'react';

const PaymentSuccess = () => {
  return (
    <div className='h-[100vh] flex flex-col items-center mt-10'>
        <h2>Success</h2>
        <h5>Thank you for your purchase!</h5>
    </div>
  );
}

export default PaymentSuccess;
